define('charts/charthelpers',["require", "exports", "../util/bounds"], function (require, exports, bounds_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getLaserBounds = exports.getBounds = exports.checkDistance = exports.closestPoint = void 0;
    // Maximum focus distance
    var focusDistance = 100;
    /**
     * Find the closest data point to the mouse pointer
     */
    function closestPoint(tracks, opt, x0, y0) {
        var best;
        var bestDist = Infinity;
        for (var _i = 0, _a = Object.keys(tracks); _i < _a.length; _i++) {
            var trackId = _a[_i];
            var track = tracks[trackId];
            for (var _b = 0, _c = track.trimmedData(); _b < _c.length; _b++) {
                var d = _c[_b];
                var deltaX = opt.fx(d) - x0;
                var deltaY = opt.fy(d) - y0;
                var dist2 = deltaX * deltaX + deltaY * deltaY; // distance^2
                if (dist2 < bestDist) {
                    best = [d, track];
                    bestDist = dist2;
                }
            }
        }
        return best;
    }
    exports.closestPoint = closestPoint;
    /**
     * Check if mouse event is close enough to closest point
     */
    function checkDistance(chart, opt, closest, evnt) {
        // Check distance in screen space
        var deltaX = chart.xAxis.scale(opt.fx(closest)) - d3.pointer(evnt)[0];
        var deltaY = chart.yAxis[0].scale(opt.fy(closest)) - d3.pointer(evnt)[1];
        var dist2 = deltaX * deltaX + deltaY * deltaY;
        return dist2 < focusDistance * focusDistance;
    }
    exports.checkDistance = checkDistance;
    /**
     * Finds the bounds of the data series
     */
    function getBounds(tracks, options) {
        var bounds = options.inner(); // Note: this assumes we can mutate inner
        for (var _i = 0, _a = Object.keys(tracks); _i < _a.length; _i++) {
            var trackId = _a[_i];
            var trimmedData = tracks[trackId].trimmedData();
            (0, bounds_1.expandBounds)(bounds, trimmedData, function (d) { return options.fx(d); }, function (d) { return options.fy(d); });
        }
        return bounds;
    }
    exports.getBounds = getBounds;
    /**
     * Finds the bounds of the laser series
     */
    function getLaserBounds(tracks, options) {
        var bounds = options.inner(); // Note: this assumes we can mutate inner
        for (var _i = 0, _a = Object.keys(tracks); _i < _a.length; _i++) {
            var trackId = _a[_i];
            var track = tracks[trackId];
            if (track.trackType === "laser") {
                var data = tracks[trackId].data;
                (0, bounds_1.expandBounds)(bounds, data, function (d) { return options.fx(d); }, function (d) { return options.fy(d); });
            }
        }
        return bounds;
    }
    exports.getLaserBounds = getLaserBounds;
});
//# sourceMappingURL=/assets/javascripts/charts/charthelpers.js.map;
